import '../styles/globals.css'
import type { AppProps } from 'next/app'
import {
  ReadingEggsFooter,
  ReadingEggsHeaderNew,
  getMenuJson,
} from '@marketing-sites/ui'
import React, { useEffect } from 'react'

import { gtmVirtualPageView, siteLocale } from '@marketing-sites/utils'

import Head from 'next/head'
import Script from 'next/script'
import { useRouter } from 'next/router'
import Provider from '@/pages/provider'

const gtmTagId = process.env['NEXT_PUBLIC_GTM_ID'] ?? ''
const menuJson = getMenuJson(siteLocale)

function MyApp({ Component, pageProps }: AppProps<Record<string, unknown>>) {
  const router = useRouter()

  useEffect(() => {
    const mainDataLayer = {
      pageTypeName: pageProps['page'] ?? null,
      url: router.asPath,
    }

    gtmVirtualPageView(mainDataLayer)
  }, [pageProps, router.asPath])

  const Anchor = ({
    href,
    ...props
  }: React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
    let resolvedHref =
      href && !/^(https?:\/\/|\/|#|mailto:|tel:)/.exec(href) ? `/${href}` : href

    if (resolvedHref && !/^(mailto:|tel:|#)/.test(resolvedHref)) {
      const splitAt = resolvedHref.search(/[?#]/)
      const pathEnd = splitAt === -1 ? resolvedHref.length : splitAt
      if (resolvedHref[pathEnd - 1] !== '/') {
        resolvedHref =
          resolvedHref.slice(0, pathEnd) + '/' + resolvedHref.slice(pathEnd)
      }
    }

    return <a href={resolvedHref} {...props} />
  }

  return (
    <>
      <Head>
        {/* vag-rundschrift-d */}
        <link rel="preconnect" href="https://use.typekit.net/" />
        <link rel="stylesheet" href="https://use.typekit.net/avf2qfu.css" />
      </Head>
      <Provider>
        <ReadingEggsHeaderNew
          menuJson={menuJson}
          LinkComp={Anchor}
          currentPath={useRouter().pathname}
          locale={siteLocale}
        />
        <Script id="gtmScript">
          {`(function(w,d,s,l,i){w[l] = w[l] || [];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmTagId}');`}
        </Script>
        <Script id="vwoCode">
          {`window._vwo_code=window._vwo_code || (function() {
            var account_id=599,
            version = 1.5,
            settings_tolerance=2000,
            library_tolerance=2500,
            use_existing_jquery=false,
            is_spa=1,
            hide_element='body',
            hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
            /* DO NOT EDIT BELOW THIS LINE */
            f=false,d=document,vwoCodeEl=d.querySelector('#vwoCode'),code={use_existing_jquery:function(){return use_existing_jquery},library_tolerance:function(){return library_tolerance},hide_element_style:function(){return'{'+hide_element_style+'}'},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=d.createElement('script');t.fetchPriority='high';t.src=e;t.type='text/javascript';t.onerror=function(){window._vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(t)},getVersion:function(){return version},getMatchedCookies:function(e){var t=[];if(document.cookie){t=document.cookie.match(e)||[]}return t},getCombinationCookie:function(){var e=code.getMatchedCookies(/(?:^|;)\\s?(_vis_opt_exp_\\d+_combi=[^;$]*)/gi);e=e.map(function(e){try{var t=decodeURIComponent(e);if(!/_vis_opt_exp_\\d+_combi=(?:\\d+,?)+\\s*$/.test(t)){return''}return t}catch(e){return''}});var i=[];e.forEach(function(e){var t=e.match(/([\\d,]+)/g);t&&i.push(t.join('-'))});return i.join('|')},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;window.settings_timer=setTimeout(function(){window._vwo_code.finish()},settings_tolerance);var e=d.createElement('style'),t=hide_element?hide_element+'{'+hide_element_style+'}':'',i=d.getElementsByTagName('head')[0];e.setAttribute('id','_vis_opt_path_hides');vwoCodeEl&&e.setAttribute('nonce',vwoCodeEl.nonce);e.setAttribute('type','text/css');if(e.styleSheet)e.styleSheet.cssText=t;else e.appendChild(d.createTextNode(t));i.appendChild(e);var n=this.getCombinationCookie();this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+ +is_spa+'&vn='+version+(n?'&c='+n:''));return settings_timer}};window._vwo_settings_timer = code.init();return code;}());
          `}
        </Script>
        <Component {...pageProps} />
        <ReadingEggsFooter />
      </Provider>
    </>
  )
}

export default MyApp
